module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "demo-chart-bubble"
    }
  }, [_vm._v("\n\tchart bubble\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-089dec32!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/demoChartBubble.vue
// module id = 3522
// module chunks = 1